import { useQuery } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../api/snackbarSlice';
import { apiClient } from '../../../utils/axios';
import { amlScreeningBasePath } from './amlScreeningPaths';
import { useAmlScreeningErrorMessage } from './useAmlScreeningErrorMessage';

export const fetchCustomerAmlScreening = async ({ queryKey }) => {
  const profileId = queryKey[1];
  const { data } = await apiClient.get(amlScreeningBasePath(profileId));
  return data;
};

export const useGetCustomerAmlScreeningHandler = (profileId, enabled = true) => {
  const dispatch = useDispatch();
  const getErrorMessage = useAmlScreeningErrorMessage();
  const shownErrorKeyRef = useRef(null);

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['customers', profileId, 'aml-screening'],
    queryFn: fetchCustomerAmlScreening,
    enabled: Boolean(profileId) && enabled,
    staleTime: 60 * 1000,
    retry: 1,
  });

  useEffect(() => {
    if (!isError) {
      shownErrorKeyRef.current = null;
      return;
    }

    const errorKey = error?.response?.data?.code || error?.message;
    if (!errorKey || shownErrorKeyRef.current === errorKey) {
      return;
    }

    shownErrorKeyRef.current = errorKey;
    dispatch(showSnackbar({ message: getErrorMessage(error), severity: 'error' }));
  }, [dispatch, error, getErrorMessage, isError]);

  return {
    amlScreeningData: data,
    isLoading,
    isError,
    refetch,
  };
};
